import React, { useCallback, useMemo } from "react";
import { motion } from "framer-motion";
import Button from "../../../../components/Button";
import { useChatsUIContext } from "../../context/ChatsContext";
import { NewChatActionsStyle } from "../../style";
import { useChatSelector } from "../../hooks/reduxHook";
import { shallowEqual } from "react-redux";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

const ActionButtonList = [
  {
    key: "explore-page",
    active: true,
  },
  {
    key: "create-group",
    active: true,
  },
  {
    key: "suggestion-people",
    active: true,
  },
];

const NewChatActions = () => {
  const { t } = useAppTranslation("common");
  const isAdmin = useChatSelector(
    (state: any) => state.chats.isAdmin,
    shallowEqual
  );

  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
      setNavigatePage: chatsContext?.setNavigatePage,
      newChatActionsShow: chatsContext?.newChatActionsShow,
      setNewChatActionsShow: chatsContext?.setNewChatActionsShow,
    };
  }, [
    chatsContext?.navigatePage,
    chatsContext?.setNavigatePage,
    chatsContext?.newChatActionsShow,
    chatsContext?.setNewChatActionsShow,
  ]);

  const handleClose = useCallback(() => {
    chatsUIProps?.setNewChatActionsShow?.(false);
  }, []);

  const handleNewAction = useCallback((action: string) => {
    const history = chatsUIProps?.navigatePage?.history || [];
    const key = chatsUIProps?.navigatePage?.key || [];

    const duplicateHistory = history?.at(-1) === action;
    chatsUIProps?.setNavigatePage?.({
      current: action,
      key: duplicateHistory ? key : [...key, "home"],
      history: duplicateHistory ? history : [...history, action],
    });
    handleClose();
  }, []);

  return (
    <NewChatActionsStyle
      as={motion.div}
      className="gap-4"
      initial={{ left: "-500px", opacity: 0 }}
      animate={{ left: "0px", opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      {ActionButtonList.map((item, index) => {
        if (item.key === "create-group" && !isAdmin) return null;
        return (
          <div
            key={item?.key ?? index}
            className="rounded-btn-chat"
            id="btn-newChats"
          >
            <Button
              variant="rounded"
              disabled={!item?.active}
              onClick={() => item.active && handleNewAction(item?.key)}
              className="border-0"
            >
              <span className="w-100 fs-6">
                {item?.key === "explore-page"
                  ? t("chat.explore")
                  : item?.key === "create-group"
                  ? t("chat.actions.newGroup")
                  : item?.key === "suggestion-people"
                  ? t("chat.actions.newChat")
                  : ""}
              </span>
            </Button>
          </div>
        );
      })}

      <motion.div
        initial={{ left: "-500px", opacity: 0 }}
        animate={{ left: "0px", opacity: 1 }}
        transition={{ transition: 2 }}
      >
        <Button onClick={handleClose} variant="default">
          {t("actions.cancel")}
        </Button>
      </motion.div>
    </NewChatActionsStyle>
  );
};

export default NewChatActions;
